import { employeeExperienceTranslate } from "../../../../i18n/translatedMessages";

export const askesES = [
  {
    id: 1,
    type: "cultural",
    question: employeeExperienceTranslate.culturaQuestionEE1,
  },
  {
    id: 2,
    type: "cultural",
    question: "Me encanta vestirme y comportarme de manera formal en el trabajo.",
  },
  {
    id: 3,
    type: "cultural",
    question:
      "Para mi es importante que exista reciclaje y uso inteligente de los recursos de la empresa.",
  },
  {
    id: 4,
    type: "cultural",
    question:
      "Me gusta que exista absoluta tolerancia a la orientación sexual de mis compañeros y jefaturas.",
  },
  {
    id: 5,
    type: "cultural",
    question:
      "Me siento más cómodo/a en una empresa innovadora que en una extremadamente tradicional.",
  },
  {
    id: 6,
    type: "cultural",
    question:
      "Es entendible que una empresa tenga teléfonos y correos para hacer denuncias confidenciales.",
  },
  {
    id: 7,
    type: "carrera",
    question: "Ser competitivo es clave para ser exitoso en el trabajo.",
  },
  {
    id: 8,
    type: "carrera",
    question:
      "Si tengo que elegir entre desarrollo profesional versus sueldo, prefiero desarrollo profesional.",
  },
  {
    id: 9,
    type: "carrera",
    question: "Quiero asumir cargos de más poder rápidamente.",
  },
  {
    id: 10,
    type: "carrera",
    question:
      "Cuidar lo que dices y ser políticamente correcto al opinar, es clave para ser exitoso en el trabajo.",
  },
  {
    id: 11,
    type: "carrera",
    question:
      "Es importante esconder los tatuajes y cuidar la apariencia física en el trabajo para ser exitoso.",
  },
  {
    id: 12,
    type: "carrera",
    question: "Si mi jefe no conversa conmigo sobre mi desarrollo de carrera, lo entiendo.",
  },
  {
    id: 13,
    type: "liderazgo",
    question: "Es entendible que los Directores o Gerentes tengan estacionamientos privilegiados.",
  },
  {
    id: 14,
    type: "liderazgo",
    question:
      "Es entendible que la comunicación de los jefes pueda tornarse más dura en ocasiones.",
  },
  {
    id: 15,
    type: "liderazgo",
    question:
      "Es entendible que el Gerente General sea cercano con algunas personas y con otras no.",
  },
  {
    id: 16,
    type: "liderazgo",
    question: "El tema del liderazgo es lo más importante.",
  },
  {
    id: 17,
    type: "liderazgo",
    question: "Si fuera parte de un equipo de alto desempeño, trabajaría hasta más tarde.",
  },
  {
    id: 18,
    type: "liderazgo",
    question: "Me encanta que mi jefe me pregunte qué opino sobre su liderazgo y gestión.",
  },
  {
    id: 19,
    type: "interese",
    question: "Me siento más cómodo en una empresa con sindicato(s).",
  },
  {
    id: 20,
    type: "interese",
    question: "Elegir mi horario de entrada y salida, es un factor clave para mi.",
  },
  {
    id: 21,
    type: "interese",
    question: "Salir más temprano los viernes, es un factor clave para mi.",
  },
  {
    id: 22,
    type: "interese",
    question:
      "Tener días libres por sobre lo legal en caso de matrimonio o AUC, es un factor clave para mí.",
  },
  {
    id: 23,
    type: "interese",
    question:
      "Tener los mejores beneficios para las mujeres en pre y post natal, es un factor clave para mi.",
  },
  {
    id: 24,
    type: "interese",
    question:
      "Que la empresa apoye las actividades deportivas de los colaboradores, es un factor clave para mi.",
  },
];
export const askesPT = [
  {
    id: 1,
    type: "cultural",
    question: "Haja um bom equilíbrio de homens e mulheres em cargos gerenciais.",
  },
  { id: 2, type: "cultural", question: "Vestirse formalmente no trabalho." },
  {
    id: 3,
    type: "cultural",
    question: "Façam reciclagem e uso inteligente dos recursos da empresa.",
  },
  {
    id: 4,
    type: "cultural",
    question: "Haja tolerância absoluta à orientação sexual de meus colegas e gerentes.",
  },
  {
    id: 5,
    type: "cultural",
    question: "Estar em um ambiente inovador e não extremamente tradicional.",
  },
  {
    id: 6,
    type: "cultural",
    question: "Telefones e e-mails para fazer denuncias confidenciais.",
  },
  {
    id: 7,
    type: "carrera",
    question: "Ser competitivo para ter sucesso no trabalho.",
  },
  {
    id: 8,
    type: "carrera",
    question: "Que o foco seja o desenvolvimento profissional, e não tanto o salário.",
  },
  { id: 9, type: "carrera", question: "Ser promovido em pouco tempo." },
  {
    id: 10,
    type: "carrera",
    question:
      "Ter atenção no que você diz, como se expressa e ser politicamente correto em sua opinião.",
  },
  {
    id: 11,
    type: "carrera",
    question: "Esconder tatuagens e cuidar da aparência física no trabalho para ter sucesso.",
  },
  {
    id: 12,
    type: "carrera",
    question: "Que os chefes conversem com suas equipes sobre desenvolvimento de carreira.",
  },
  {
    id: 13,
    type: "liderazgo",
    question: "Diretores ou Gerentes tenham vagas de estacionamento privilegiadas.",
  },
  {
    id: 14,
    type: "liderazgo",
    question: "A comunicação com os chefes possa ser difícil às vezes.",
  },
  {
    id: 15,
    type: "liderazgo",
    question: "O Gerente Geral seja próximo de algumas pessoas e não de outras.",
  },
  {
    id: 16,
    type: "liderazgo",
    question: "A liderança seja o mais importante.",
  },
  {
    id: 17,
    type: "liderazgo",
    question: "Uma equipe de alto desempenho, trabalhe mais.",
  },
  {
    id: 18,
    type: "liderazgo",
    question: "Que os chefes peçam a opinião de suas equipes sobre sua liderança e gestão.",
  },
  {
    id: 19,
    type: "interese",
    question: "Trabalhar em uma empresa que tenha sindicatos.",
  },
  { id: 20, type: "interese", question: "Trabalhar com horário flexível." },
  { id: 21, type: "interese", question: "Trabalhar no modelo home-office." },
  {
    id: 22,
    type: "interese",
    question: "Ter direito a dias livres adicionais.",
  },
  {
    id: 23,
    type: "interese",
    question: "Tenha os melhores benefícios para as mulheres no pré e pós natal.",
  },
  {
    id: 24,
    type: "interese",
    question: "Que a empresa apoie as atividades esportivas dos colaboradores.",
  },
];
